export default __webpack_public_path__ + "img/0ce332e6ab29186e69fa3d55c66e2a7d.svg";